import React, { useState } from 'react'
import { View } from 'react-native'
import { RouteProp, useRoute } from '@react-navigation/native'
import { useDispatch } from 'react-redux'
import { BottomSheet } from '@src/components'
import { Input } from '@src/components/base'
import { StyleService, useStyleSheet } from '@src/style/service'
import { useSnack } from '@utils'
import { useGoBack } from '@src/utils/navigation'
import { AppStackParamList } from '@navigation/types'

export const UpsertQuickPromptModal = () => {
  const styles = useStyleSheet(themedStyles)
  const dispatch = useDispatch()
  const showSnack = useSnack()
  const goBack = useGoBack()
  const route = useRoute<RouteProp<AppStackParamList, 'UpsertQuickPromptModal'>>()

  const { id, title: initialTitle, text: initialText } = route.params || {}
  const isEditing = !!id

  const [title, setTitle] = useState(initialTitle || '')
  const [text, setText] = useState(initialText || '')
  const [isSubmitting, setIsSubmitting] = useState(false)

  const isFormValid = title.trim().length > 0 && text.trim().length > 0

  const handleSubmit = () => {
    if (!isFormValid) {
      return
    }

    setIsSubmitting(true)

    if (isEditing) {
      dispatch({
        type: 'nora/updateChatbotQuickPrompt',
        payload: { id, title: title.trim(), text: text.trim() },
        success: goBack,
        failure: () => {
          showSnack('Failed to update quick prompt', null, 'error')
          setIsSubmitting(false)
        },
      })
      return
    }

    dispatch({
      type: 'nora/createChatbotQuickPrompt',
      payload: { title: title.trim(), text: text.trim() },
      success: goBack,
      failure: () => {
        showSnack('Failed to create quick prompt', null, 'error')
        setIsSubmitting(false)
      },
    })
  }

  return (
    <BottomSheet
      header={isEditing ? 'Edit Custom Prompt' : 'Custom Prompt'}
      primaryButton={{
        text: isSubmitting ? 'Saving...' : 'Save',
        onPress: handleSubmit,
        disabled: !isFormValid || isSubmitting,
      }}
      secondaryButton={{
        text: 'Cancel',
        onPress: goBack,
      }}
      buttonDirection="column-reverse"
    >
      <View style={styles.content}>
        <Input
          label="Title"
          placeholder="e.g., Morning routine"
          value={title}
          onChangeText={setTitle}
          maxLength={100}
        />
        <Input
          label="Prompt"
          placeholder="e.g., What should I eat for breakfast?"
          value={text}
          onChangeText={setText}
          multiline
          numberOfLines={3}
        />
      </View>
    </BottomSheet>
  )
}

const themedStyles = StyleService.create({
  content: {
    gap: 16,
  },
})
